var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.measure_data)?_c('v-card-text',_vm._l((_vm.main_measures),function(measure){return _c('div',{key:measure.id},[_c('h3',{staticClass:"text-h5 mb-3"},[_vm._v(_vm._s(measure.public_name)+":")]),_c('PeriodViz',{ref:"period_viz",refInFor:true,attrs:{"measure_data":_vm.measure_data,"measure":measure.name}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }